var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_6950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6719 1.64684C7.98647 1.64684 1.75621 7.87709 1.75621 15.5625C1.75621 23.2479 7.98647 29.4782 15.6719 29.4782C23.3573 29.4782 29.5875 23.2479 29.5875 15.5625C29.5875 7.87709 23.3573 1.64684 15.6719 1.64684ZM0.671875 15.5625C0.671875 7.27823 7.3876 0.5625 15.6719 0.5625C23.9561 0.5625 30.6719 7.27823 30.6719 15.5625C30.6719 23.8468 23.9561 30.5625 15.6719 30.5625C7.3876 30.5625 0.671875 23.8468 0.671875 15.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.158 10.2639C23.4265 10.5323 23.4265 10.9677 23.158 11.2361L13.533 20.8611C13.2645 21.1296 12.8292 21.1296 12.5607 20.8611L8.18574 16.4861C7.91725 16.2177 7.91725 15.7823 8.18574 15.5139C8.45422 15.2454 8.88953 15.2454 9.15801 15.5139L13.0469 19.4027L22.1857 10.2639C22.4542 9.99538 22.8895 9.99538 23.158 10.2639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_6950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.671875 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.254727e6388ad2e4c7b34c0aa6b7151d.svg";
export { ForwardRef as ReactComponent };